import Vue from 'vue';
import config from '@/config';
import utils from '@/utils';
import store from '@/store';
//import notify from "../notify";

export default {
  req (endpoint, data, options = {}) {
    return new Promise((resolve) => {
      let params = {};
      let body = null;
      if (endpoint.method == 'POST' || endpoint.method == 'PUT' || endpoint.method == 'DELETE') {
        body = data;
      } else {
        params = data;
      }
      params = { ...store.getters.getAuthParams, ...params };
      /*params.userID = utils.getCookie("userID");
      params.token  = utils.getCookie("token");*/

      Vue.http({
        url: config.SERVER_DOMAIN + endpoint.url,
        method: endpoint.method,
        params,
        body: { data: body },
      }).then(
        (response) => {
          resolve(response);
          if (options && options.finally)
            options.finally();
        },
        (error) => {
          let handled = false;
          if (options && options.onError)
            handled = !!options.onError(error);
          if (!handled)
            utils.httpError(error);
          if (options && options.finally)
            options.finally();
        },
      ); //then
    }); //Promise
  } // req()

  ,
  fakeResponse (msg) {
    return Promise.resolve({ body: { msg } });
  },
} // api
